import styled, { css } from 'styled-components'
import Modal from '../../../../common/modal'

import { CalendarIcon, LocationPinIcon } from '../../../../common/icons'
import { InputIcon } from '../../../../search-result-listing/header-section/searchbar/widget-styles'
import type { StyledSvgComponent } from '../../../../../types/svg'

export const AllInputsModalContainer = styled(Modal)(
    ({ theme }) => css`
        & .Overlay {
            align-items: flex-start;
        }

        & .Modal {
            width: ${theme.layout.fill};
            border-radius: 0;
        }
    `,
)

export const InputsContainer = styled.div(
    ({ theme }) => css`
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        border-radius: ${theme.typography.border.radius.xLarge};
        margin: 0 ${theme.spacing.medium};
    `,
)

export const Row = styled.div(
    ({ theme }) => css`
        display: flex;
        border-bottom: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};

        &:last-child {
            border-bottom: none;
        }
    `,
)

export const Col = styled.div(
    ({ theme }) => css`
        display: flex;
        align-items: center;
        flex: 1 1 0;
        height: ${theme.layout.fill};
        border-right: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        cursor: pointer;

        &:last-child {
            border-right: none;
        }
    `,
)

export const Input = styled.input.attrs({
    disabled: true,
    'aria-disabled': false,
})(
    ({ theme }) => css`
        width: ${theme.layout.fill};
        background-color: transparent;
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.xLarge};
        padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xxLarge};
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: text;
        pointer-events: none;
    `,
)

const AllInputsInputIcon = styled(InputIcon)(
    ({ theme }) => css`
        left: ${theme.spacing.medium};
    `,
)

export const DatePickerIcon = styled(AllInputsInputIcon as StyledSvgComponent).attrs({ as: CalendarIcon })``
export const LocationPickerIcon = styled(AllInputsInputIcon as StyledSvgComponent).attrs({ as: LocationPinIcon })``
